(() => {
  const normalizeRaw = value => {
    const raw = String(value || '').trim().toLowerCase().replaceAll('-', '_').replaceAll(' ', '_');
    if (!raw) return '';
    if (['direct_buy','buy','order'].includes(raw)) return 'DIRECT_BUY';
    if (['quote','quote_only','quote_required'].includes(raw)) return 'QUOTE_REQUIRED';
    if (['custom','custom_required','custom_request'].includes(raw)) return 'CUSTOM';
    if (['engineering','engineering_review','manual_review_required'].includes(raw)) return 'ENGINEERING_REVIEW';
    if (['manual_confirm','check_availability','availability_check'].includes(raw)) return 'CHECK_AVAILABILITY';
    return raw.toUpperCase();
  };

  const inspect = root => {
    const nodes = [];
    if (root?.matches?.('[data-oxx-route]')) nodes.push(root);
    root?.querySelectorAll?.('[data-oxx-route]').forEach(node => nodes.push(node));
    const rows = [];
    for (const node of nodes) {
      if (node.dataset.oxxRouteDriftChecked === '1') continue;
      node.dataset.oxxRouteDriftChecked = '1';
      const finalRoute = String(node.dataset.oxxRoute || '').trim().toUpperCase();
      const rawValue = String(node.dataset.oxxRouteRaw || '').trim();
      const rawRoute = normalizeRaw(rawValue);
      const status = !rawRoute ? 'MISSING' : rawRoute === finalRoute ? 'MATCH' : 'CONFLICT';
      node.dataset.oxxRouteDrift = status;
      rows.push({
        status,
        raw: rawValue || null,
        normalizedRaw: rawRoute || null,
        final: finalRoute || null,
        handle: node.closest('[data-product-handle]')?.dataset.productHandle || null,
        title: node.querySelector?.('h1,h2')?.textContent?.trim() || null
      });
    }
    if (!window.OXX_ROUTE_DRIFT) window.OXX_ROUTE_DRIFT = [];
    window.OXX_ROUTE_DRIFT.push(...rows);
    const conflicts = rows.filter(row => row.status === 'CONFLICT');
    if (conflicts.length) console.warn('[OXX ROUTE DRIFT] raw route_type is non-final; Commercial Router output used.', conflicts);
    return rows;
  };

  const boot = () => {
    inspect(document);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) if (node.nodeType === 1) inspect(node);
      }
    });
    observer.observe(document.documentElement, {childList:true,subtree:true});
    window.OXXRouteDriftValidator = {inspect, normalizeRaw};
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();